<template>
  <footer class="tw:grid tw:grid-cols-1 tw:gap-2.5">
    <slot />
    <slot name="secondary" />
  </footer>
</template>
